import axios from "axios";
import {
  GET_ACTIVITIES_USER,
  SET_USER_PRESENCE,
  GET_CURRENT_USER_STATUS,
  UPDATE_DAY_TYPE,
  UPDATE_STATUT_JOUR,
} from "../types";
import { successAlert, errorAlert } from "../alertActions";

export const getActivitieUser =(value)=>(dispatch)=>{
    axios
    .post("/api/rh/getActivitieUser",value)
    .then((res)=>{
        dispatch({
            type:GET_ACTIVITIES_USER,
            payload:res.data
        })
    })
    .catch((error)=>{
      console.log(`erreur rh action :${error}`)
      errorAlert("Erreur lors de la récupération des données !")
      dispatch({
        type:GET_ACTIVITIES_USER,
        payload:[]
      })
    })
}



// Compteur monotonique : ignore les réponses obsolètes quand plusieurs
// recherches (ou refresh post-dayType) se chevauchent.
let dailyPresenceRequestSeq = 0;

export const clearMonthlyPresence = () => (dispatch) => {
  dailyPresenceRequestSeq++;
  dispatch({
    type: SET_USER_PRESENCE,
    payload: { records: [], summary: null },
  });
};

export const getDailyPresenceByUser = (body) => async (dispatch) => {
  const requestId = ++dailyPresenceRequestSeq;
  try {
    const res = await axios.post("/api/dailyPresence/dailyPresenceByUser",body);
    if (requestId !== dailyPresenceRequestSeq) return false;
    // Le backend renvoie { records, summary } depuis la refacto summary.
    // On dispatche les deux pour alimenter monthlyPresenceByUser (tableau)
    // et monthlyPresenceSummary (agrégats mensuels) séparément dans le reducer.
    dispatch({
      type: SET_USER_PRESENCE,
      payload: { records: res.data.records, summary: res.data.summary },
    });
    return true;
  } catch (error) {
    if (requestId !== dailyPresenceRequestSeq) return false;
    console.error("Erreur récupération présence :", error);
    errorAlert("Erreur lors de la récupération des données de présence !");
    dispatch({
      type: SET_USER_PRESENCE,
      payload: { records: [], summary: null },
    });
    return false;
  }
};

export const updateDayType = (body) => async (dispatch) => {
  const { agentId, year, month, ...updatePayload } = body;
  try {
    const res = await axios.post("/api/dailyPresence/updateDayType", updatePayload);

    // dayType impacte hProdRetenue, retard, isAnomaly, isEligible et le summary KPI :
    // recharger le mois entier depuis le backend (source de vérité unique).
    if (agentId && year && month) {
      const requestId = ++dailyPresenceRequestSeq;
      try {
        const refresh = await axios.post("/api/dailyPresence/dailyPresenceByUser", {
          agentId,
          year,
          month,
        });
        if (requestId !== dailyPresenceRequestSeq) return;
        dispatch({
          type: SET_USER_PRESENCE,
          payload: { records: refresh.data.records, summary: refresh.data.summary },
        });
      } catch (refreshError) {
        if (requestId !== dailyPresenceRequestSeq) return;
        console.error("Erreur refresh présence après dayType :", refreshError);
        errorAlert("Type mis à jour, mais erreur lors du rafraîchissement des données.");
        // Clear stale data so the UI doesn't show an inconsistent state
        // (row already updated by the first call, but summary still reflects old values).
        dispatch({ type: SET_USER_PRESENCE, payload: { records: [], summary: null } });
        return;
      }
    } else {
      dispatch({
        type: UPDATE_DAY_TYPE,
        payload: { presenceId: body.presenceId, dayType: res.data.dayType },
      });
    }

    successAlert("Type de jour mis à jour !");
  } catch (error) {
    console.error("Erreur updateDayType :", error);
    errorAlert("Erreur lors de la mise à jour du type de jour.");
  }
};

export const bulkSetDayType = (body) => async (dispatch) => {
  const { year, month, ...payload } = body;
  // payload = { agentId, startDate, endDate, value, leaveTypeCode, note }
  try {
    await axios.post("/api/dailyPresence/bulkSetDayType", payload);

    // Recharge le mois courant pour refléter les shells créés
    if (payload.agentId && year && month) {
      const requestId = ++dailyPresenceRequestSeq;
      try {
        const refresh = await axios.post("/api/dailyPresence/dailyPresenceByUser", {
          agentId: payload.agentId,
          year,
          month,
        });
        if (requestId !== dailyPresenceRequestSeq) return;
        dispatch({
          type: SET_USER_PRESENCE,
          payload: { records: refresh.data.records, summary: refresh.data.summary },
        });
      } catch (refreshError) {
        if (requestId !== dailyPresenceRequestSeq) return;
        console.error("Erreur refresh après bulk dayType :", refreshError);
        errorAlert("Type posé, mais erreur lors du rafraîchissement des données.");
        // Clear stale data so the UI doesn't show an inconsistent state.
        dispatch({ type: SET_USER_PRESENCE, payload: { records: [], summary: null } });
        return;
      }
    }

    successAlert("Type de jour posé sur la plage sélectionnée !");
  } catch (error) {
    console.error("Erreur bulkSetDayType :", error);
    errorAlert("Erreur lors de la mise à jour en bloc.");
  }
};


export const updateStatutJour = (body) => async (dispatch) => {
  const { agentId, year, month, ...updatePayload } = body;
  try {
    await axios.post("/api/dailyPresence/updateStatutJour", updatePayload);

    // dayStatus alimente _joursAbsents/_joursPresents du summary → refresh complet
    if (agentId && year && month) {
      const requestId = ++dailyPresenceRequestSeq;
      try {
        const refresh = await axios.post("/api/dailyPresence/dailyPresenceByUser", {
          agentId,
          year,
          month,
        });
        if (requestId !== dailyPresenceRequestSeq) return;
        dispatch({
          type: SET_USER_PRESENCE,
          payload: { records: refresh.data.records, summary: refresh.data.summary },
        });
      } catch (refreshError) {
        if (requestId !== dailyPresenceRequestSeq) return;
        console.error("Erreur refresh présence après statutJour :", refreshError);
        errorAlert("Statut mis à jour, mais erreur lors du rafraîchissement des données.");
        dispatch({ type: SET_USER_PRESENCE, payload: { records: [], summary: null } });
        return;
      }
    } else {
      dispatch({
        type: UPDATE_STATUT_JOUR,
        payload: { presenceId: body.presenceId, statutJour: body.value },
      });
    }

    successAlert("Statut du jour mis à jour !");
  } catch (error) {
    console.error("Erreur updateStatutJour :", error);
    errorAlert("Erreur lors de la mise à jour du statut.");
  }
};

// Raisons d'absence de LogOut, formulées en langage métier pour l'admin (aucun
// détail technique : ni nom de fenêtre, ni source de planning, ni tolérance).
const RAISONS_SANS_LOGOUT = {
  already_closed:        "la journée était déjà clôturée",
  no_activity_in_window: "aucune activité pendant les heures planifiées",
  no_planning_window:    "aucun planning enregistré pour ce jour",
  no_daily_presence:     "aucune présence enregistrée pour ce jour",
};

// Refus de l'API traduits pour l'admin. Le back renvoie un `code` stable + un
// `message` technique destiné aux logs ; la formulation utilisateur vit ici.
const ERREURS_FORCE_LOGOUT = {
  legacy_date_format:
    "Cette journée est enregistrée dans un ancien format de date : elle doit être migrée avant de pouvoir être clôturée.",
  day_not_finished:
    "Journée non terminée : la clôture n'est possible qu'à partir du lendemain.",
};

/**
 * Rattrapage manuel du LogOut automatique pour UN agent / UN jour (admin).
 *
 * Applique exactement la même vérification que le cron du matin. Si rien n'est
 * trouvé dans la fenêtre, le backend n'écrit rien → on informe sans rafraîchir.
 *
 * @param body { presenceId, agentId, year, month }
 */
export const forceAutoLogOutDay = (body) => async (dispatch) => {
  const { presenceId, agentId, year, month } = body;
  try {
    const res = await axios.post("/api/rh/forceAutoLogOut", { presenceId });
    const { autoLogout, reason, logOutAtLocal, dayClosed } = res.data;

    // Aucune écriture côté serveur : pas besoin de recharger le mois. Le message dit
    // deux choses seulement : aucun LogOut, et si la journée est clôturée ou non.
    if (!autoLogout) {
      const raison = RAISONS_SANS_LOGOUT[reason] || reason;
      successAlert(
        dayClosed
          ? `Aucun LogOut à ajouter : ${raison}.`
          : `Aucun LogOut enregistré : ${raison}. La journée n'est pas clôturée.`
      );
      return;
    }

    // Un LogOut a été créé → il impacte logout, heures et summary : on recharge
    // le mois depuis le backend (source de vérité unique).
    if (agentId && year && month) {
      const requestId = ++dailyPresenceRequestSeq;
      try {
        const refresh = await axios.post("/api/dailyPresence/dailyPresenceByUser", {
          agentId,
          year,
          month,
        });
        if (requestId !== dailyPresenceRequestSeq) return;
        dispatch({
          type: SET_USER_PRESENCE,
          payload: { records: refresh.data.records, summary: refresh.data.summary },
        });
      } catch (refreshError) {
        if (requestId !== dailyPresenceRequestSeq) return;
        console.error("Erreur refresh présence après forceAutoLogOut :", refreshError);
        errorAlert("LogOut créé, mais erreur lors du rafraîchissement des données.");
        dispatch({ type: SET_USER_PRESENCE, payload: { records: [], summary: null } });
        return;
      }
    }

    successAlert(`LogOut enregistré à ${logOutAtLocal}. La journée est clôturée.`);
  } catch (error) {
   // console.error("Erreur forceAutoLogOut :", error);
    errorAlert(
      ERREURS_FORCE_LOGOUT[error.response?.data?.code] ||
        "Impossible de clôturer cette journée. Réessayez, puis signalez le problème s'il persiste."
    );
  }
};

export const getCurrentStatusByUser = (value) => async (dispatch) => {
  try {
    const res = await axios.post("/api/dailyPresence/getCurrentStatusByUser",value);
    // console.log("sdgsdgsdgsdgsdgsdgsdgsdgsdgsdgs",res)
    dispatch({
      type: GET_CURRENT_USER_STATUS,
      payload: res.data, 
    });
  //  console.log(("ppppppppppppppppppppp",res.data))
  } catch (error) {
   // console.error("Erreur récupération current statut :", error);
     dispatch({
      type: GET_CURRENT_USER_STATUS,
      payload: {}, 
    });
  }
};

